// removed by extract-text-webpack-plugin
module.exports = {"SocialIcons":"SocialIcons__SocialIcons___zR8Yv"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/SocialIcons/SocialIcons.less
// module id = 1300
// module chunks = 0 1